import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, timer } from 'rxjs';
import { catchError, delay, map } from 'rxjs/operators';
import { GoogleMap } from '@angular/google-maps';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VanTransferService } from 'src/app/core/services/vanTransfer.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { User } from 'src/app/core/models/persons.model';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import {
  Areas,
  Routes,
  RoutesAreas,
  VanTransferLocal,
} from 'src/app/core/models/vanTransfer.model';
import { UserLogan, UserLoganAirports } from 'src/app/core/models/userLogan';

import { environment } from 'src/environments/environment';
import { Loader } from '@googlemaps/js-api-loader';

@Component({
  selector: 'app-vans-routes',
  templateUrl: './vans-routes.component.html',
  styleUrls: ['./vans-routes.component.scss'],
  providers: [NgbDropdown],
})
export class VansRoutesComponent implements OnInit, AfterViewInit {
  drawingManager: any;
  route: any[] = [];
  routes: Routes[] = [];
  routesGrid: Routes[] = [];
  areas: Areas[] = [];
  routesAreas: RoutesAreas[] = [];
  localidAux: Number | null = null;

  routeInitalBool = false;
  routeAddButton = false;

  user: User;
  UserMovidaTransferAirports: UserLoganAirports = new UserLoganAirports();

  circularProgressiveWait = false;
  maps: GoogleMap | any;
  vanTransferLocal: VanTransferLocal[] = [];
  editOrAdd: boolean = false;
  markerAddMovida: boolean = false;

  localRoutesAreas: LocalRoutesAreas[] = [];
  localRoutesAreasEdit: LocalRoutesAreas[] = [];
  routesAreasPolygonEdit: any = [];
  markerMovidaEdit: LocalRoutesAreas = new LocalRoutesAreas();

  addAreasBool: boolean = false;
  routesPolyline: any[] = [];
  routesAreasPolygon: any[] = [];
  markerMovida: any[] = [];
  merkerTerminals: any[] = [];
  colorAreas: string[] = [
    '#fd5959',
    '#702283',
    '#ff9c6d',
    '#962071',
    '#fcff82',
    '#76b39d',
    '#afc5ff',
    '#fdb44b',
    '#7dd87d',
    '#003049',
    '#ff931f',
    '#8a1919',
    '#001b29',
    '#a88661',
    '#0a0aff',
  ];

  wizardState: number = 1;

  //this.polyline.getPath().getArray()[0]).lat()
  constructor(
    private modalService: NgbModal,
    private vanTransferService: VanTransferService,
    public toastService: ToastService,
    private authService: AuthService
  ) {
    this.user = this.authService.currentUserValue;
    this.UserMovidaTransferAirports.airports = this.user.airportsAllowed ?? '';
    this.UserMovidaTransferAirports.filterMovidaTransfer =
      this.user.filterMovidaTransfer ?? false;
  }

  options: google.maps.MapOptions = {
    center: { lat: -13.7972945, lng: -59.6173487 },
    zoom: 4,
  };

  loader = new Loader({
    apiKey: environment.googleMaps.key,
    version: 'weekly',
  });

  prepareLatLng(latlng: string): any {
    var latLngSplit = latlng.split(';');
    var latLngPrepared: google.maps.LatLng[] = [];
    latLngSplit.forEach((item: any) => {
      var a = item.split(',');
      if (a[0].length > 1 && a[1].length > 1) {
        latLngPrepared.push(
          new google.maps.LatLng({ lat: Number(a[0]), lng: Number(a[1]) })
        );
      }
    });

    return latLngPrepared;
  }

  prepareLatLngMarker(latlng: string): any {
    var latLngSplit = latlng.split(';');
    var titleAndLatLng: any = [];
    if (latLngSplit[latLngSplit.length - 1] == '') {
      latLngSplit.pop();
    }
    latLngSplit.forEach((item: any) => {
      var a = item.split(',');
      if (a.length > 2) {
        titleAndLatLng.push([
          a[0],
          new google.maps.LatLng({ lat: Number(a[1]), lng: Number(a[2]) }),
        ]);
      } else {
        titleAndLatLng.push([
          '1',
          new google.maps.LatLng({ lat: Number(a[1]), lng: Number(a[2]) }),
        ]);
      }
    });
    return titleAndLatLng;
  }

  prepareMaker(coord: any, movida: boolean, name: any) {
    var latLng;
    var index = 0;
    var icon =
      this.markerAddMovida || movida
        ? '../../../../assets/images/loja_movida.png'
        : '../../../../assets/images/terminal.png';
    if (typeof coord == 'string') {
      var markers: [
        { name: string; marker: google.maps.Marker; coordinates: string }
      ] = [{ marker: new google.maps.Marker(), name: '1', coordinates: '' }];
      latLng = this.prepareLatLngMarker(coord);
      latLng.forEach((item: any) => {
        const markerAux = new google.maps.Marker({
          position: item[1],
          draggable: false,
          icon: icon,
          label: item[0],
        });
        markerAux.setMap(this.drawingManager.map);
        markers.push({
          name: item[0],
          coordinates: coord,
          marker: markerAux,
        });
      });
      if (markers.length > 1) {
        markers.splice(0, 1);
      }

      return markers;
    } else {
      const markerAux = new google.maps.Marker({
        position: {
          lat: coord.lat(),
          lng: coord.lng(),
        },
        draggable: false,
        icon: icon,
        //title: `<p><span style="color: #ff0000;"><strong>${coord.dataHoraEvento}</strong></span></p>`,

        // map: this.map,
      });
      markerAux.setMap(this.drawingManager.map);
      var markerAux2: [
        { name: string; marker: google.maps.Marker; coordinates: string }
      ] = [
        {
          marker: markerAux,
          name: name.toString(),
          coordinates: coord.lat() + ',' + coord.lng(),
        },
      ];

      return markerAux2;
    }
  }
  prepareAreas(areas: string | [], quantity: number | null) {
    var latLng;
    if (typeof areas == 'string') {
      latLng = this.prepareLatLng(areas);
    } else {
      latLng = areas;
    }

    var polygon = new google.maps.Polygon({
      paths: latLng,
      strokeColor: this.colorAreas[quantity == null ? 0 : quantity],
      strokeOpacity: 0.8,
      fillColor: this.colorAreas[quantity == null ? 0 : quantity],
      fillOpacity: 0.5,
      draggable: false,
      editable: false,
    });
    polygon.setMap(this.drawingManager.map);
    return polygon;
  }
  prepareRoute(route: string | []) {
    var latLng;
    if (typeof route == 'string') {
      latLng = this.prepareLatLng(route);
    } else {
      latLng = route;
    }

    var polyline = new google.maps.Polyline({
      path: latLng,
      strokeColor: '#000db0',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      draggable: false,
      editable: false,
    });
    polyline.setMap(this.drawingManager.map);
    return polyline;
  }
  ngAfterViewInit() {
    this.initializeMap();
  }

  private async initializeMap() {
    await this.loader.importLibrary('core');
    const { Map } = (await google.maps.importLibrary(
      'maps'
    )) as google.maps.MapsLibrary;

    this.maps = new Map(
      document.getElementById('map') as HTMLElement,
      this.options
    );

    await this.loader.importLibrary('drawing');
    const { DrawingManager } = (await google.maps.importLibrary(
      'drawing'
    )) as google.maps.DrawingLibrary;

    this.drawingManager = new DrawingManager();
    this.drawingManager.drawingControlOptions = {};
  }

  ngOnInit(): void {
    this.circularProgressiveWait = true;

    this.vanTransferService
      .selectVanTransferLocal(this.UserMovidaTransferAirports)
      .subscribe((response: any) => {
        this.vanTransferLocal = response;
      });
    this.vanTransferService
      .selectRoutes(this.UserMovidaTransferAirports)
      .subscribe(
        (response: any) => {
          this.routes = response;
          var routesGridAux: any[] = [-1];
          this.routesGrid = this.routes.filter((item: Routes) => {
            return (
              routesGridAux.findIndex((value: any) => {
                routesGridAux.push(item.localId);
                return value == item.localId;
              }) < 0
            );
          });

          this.circularProgressiveWait = false;
        },
        (error: HttpErrorResponse) => {
          this.toastService.show('Erro ao carregar rotas - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
          this.circularProgressiveWait = false;
        }
      );
    this.vanTransferService.selectAreas().subscribe(
      (response: any) => {
        this.areas = response;
      },
      (error: HttpErrorResponse) => {
        this.toastService.show('Erro ao carregar areas - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
        this.circularProgressiveWait = false;
      }
    );
    this.vanTransferService.selectRoutesAreas().subscribe(
      (response: any) => {
        this.routesAreas = response;
        this.circularProgressiveWait = false;
      },
      (error: HttpErrorResponse) => {
        this.toastService.show('Erro ao rotas areas - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
        this.circularProgressiveWait = false;
      }
    );
  }
  clearDrawing() {
    this.drawingManager.drawingControl = false;
    this.drawingManager.setDrawingMode(null);
    this.drawingManager.setMap(this.drawingManager.map);
  }
  changeVisible(item: any) {
    item.routesPolyline.setVisible(!item.routesPolyline.visible);
  }
  changeVisibleArea(item: any) {
    item.forEach((itemArea: any) => {
      itemArea.polygon.setVisible(!itemArea.polygon.visible);
    });
  }
  changeEditable(item: any) {
    item.routesPolyline.setEditable(!item.routesPolyline.editable);
    item.routeWasEdit = true;
  }

  deleteRoute(index: number) {
    this.circularProgressiveWait = true;
    if (this.localRoutesAreasEdit[index].routes.id < 0) {
      this.localRoutesAreasEdit.splice(index, 1);
    } else {
      this.vanTransferService
        .deleteRoute(this.localRoutesAreasEdit[index].routes)
        .subscribe(
          (response: any) => {
            this.toastService.show('Rota deletada com sucesso', {
              classname: 'bg-success text-center text-white',
              delay: 2500,
            });
            this.circularProgressiveWait = false;
            window.location.reload();
          },
          (error: HttpErrorResponse) => {
            this.toastService.show('Erro ao deletar rota - ' + error.message, {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            });
            this.circularProgressiveWait = false;
          }
        );
    }
  }

  changeEditableArea(itemArea: any) {
    itemArea.polygon.setEditable(!itemArea.polygon.editable);
    itemArea.polygon.setDraggable(!itemArea.polygon.draggable);
    this.drawingManager.setMap(this.drawingManager.map);
    itemArea.areaWasEdit = true;
  }

  //TODO: Terminar exclusão da área
  excludeArea(item: any, indexRoute: number, indexArea: number) {
    var newOrder = 0;
    if (item.area.id < 0) {
      this.localRoutesAreasEdit[indexRoute].areas?.splice(indexArea, 1);
      this.localRoutesAreasEdit[indexRoute].areas?.forEach((element: any) => {
        element.area.order = newOrder;
        newOrder = newOrder + 1;
      });
    } else {
      this.vanTransferService.deleteArea(item.area).subscribe(
        (response: any) => {
          this.toastService.show('Area deletada com sucesso', {
            classname: 'bg-success text-center text-white',
            delay: 2500,
          });
          this.circularProgressiveWait = false;
          window.location.reload();
        },
        (error: HttpErrorResponse) => {
          this.toastService.show('Erro ao deletar area - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
          this.circularProgressiveWait = false;
        }
      );
    }
  }

  finishAddArea() {
    this.addAreasBool = false;
    this.drawingManager.drawingControl = false;
    // this.drawingManager.drawingControlOptions.drawingModes = [
    //   google.maps.drawing.OverlayType.POLYGON,
    //  ];
  }
  addArea(item: any) {
    this.addAreasBool = true;
    this.routesAreasPolygonEdit = item;
    this.drawingManager.setDrawingMode(null);
    this.drawingManager.drawingControl = true;
    this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);

    this.drawingManager.drawingControlOptions.drawingModes = [
      google.maps.drawing.OverlayType.POLYGON,
    ];
    this.drawingManager.setMap(this.drawingManager.map);
  }

  finishAddRoute() {
    this.drawingManager.drawingControl = false;
    this.drawingManager.setDrawingMode(null);
    this.drawingManager.drawingControlOptions.drawingModes = [];
    this.drawingManager.setMap(this.drawingManager.map);
    this.drawingManager = this.drawingManager;
  }

  newRoute() {
    this.finishAddRoute();
    this.localRoutesAreasEdit.push(new LocalRoutesAreas());
    this.localRoutesAreasEdit = this.localRoutesAreasEdit.reverse();
  }

  addRoute() {
    if (!this.routeInitalBool) {
      this.routeAddButton = true;
    }

    this.finishAddRoute();
    this.drawingManager.setDrawingMode(null);
    this.drawingManager.drawingControl = true;
    this.drawingManager.setDrawingMode(
      google.maps.drawing.OverlayType.POLYLINE
    );
    this.drawingManager.drawingControlOptions.drawingModes = [
      google.maps.drawing.OverlayType.POLYLINE,
    ];
    this.drawingManager.setMap(this.drawingManager.map);
  }

  saveAreas(item: LocalRoutesAreas, routeId: number) {
    this.circularProgressiveWait = true;
    item.areas?.forEach(
      (item: any) => {
        if (item.area.id < 0) {
          item.polygon
            .getPath()
            .getArray()
            .forEach((coordArea: google.maps.LatLng) => {
              item.area.coordinates =
                item.area.coordinates +
                coordArea.lat() +
                ',' +
                coordArea.lng() +
                ';';
            });
          item.area.email = this.user.email;
          this.vanTransferService.insertArea(item.area).subscribe(
            (response: any) => {
              var routesAreas: RoutesAreas = new RoutesAreas();
              routesAreas.area_id = response;
              routesAreas.routes_id = routeId;
              routesAreas.email = this.user.email;
              this.vanTransferService
                .insertRouteArea(routesAreas)
                .subscribe((response: any) => {
                  this.toastService.show('Rota e Area cadastrada com sucesso', {
                    classname: 'bg-success text-center text-white',
                    delay: 2500,
                  });
                  this.vanTransferService.reloadCache();
                  this.circularProgressiveWait = false;
                  window.location.reload();
                });
              this.circularProgressiveWait = false;
              window.location.reload();
            },
            (error: HttpErrorResponse) => {
              this.toastService.show(
                'Erro ao vincular rota com area - ' + error.message,
                {
                  classname: 'bg-danger text-center text-white',
                  delay: 10000,
                }
              );
              this.circularProgressiveWait = false;
            }
          );
        } else if (item.areaWasEdit) {
          item.area.coordinates = '';
          item.polygon
            .getPath()
            .getArray()
            .forEach((coordArea: google.maps.LatLng) => {
              item.area.coordinates =
                item.area.coordinates +
                coordArea.lat() +
                ',' +
                coordArea.lng() +
                ';';
            });
          item.area.email = this.user.email;
          this.circularProgressiveWait = true;
          this.vanTransferService
            .updateArea(item.area)
            .subscribe((response: any) => {
              this.vanTransferService.reloadCache();
              this.toastService.show('Area editada com sucesso', {
                classname: 'bg-success text-center text-white',
                delay: 2500,
              });
              this.circularProgressiveWait = false;
              window.location.reload();
            });
        }
      },
      (error: HttpErrorResponse) => {
        this.toastService.show('Erro ao editar area - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
        this.circularProgressiveWait = false;
        window.location.reload();
      }
    );
  }

  saveRoutes() {
    this.localRoutesAreasEdit.forEach((itemRoute: LocalRoutesAreas) => {
      this.circularProgressiveWait = true;
      if (itemRoute.routes.id < 0) {
        itemRoute.routes.localId = this.localRoutesAreasEdit[1].localId;
        itemRoute.routesPolyline
          .getPath()
          .getArray()
          .forEach((coordArea: google.maps.LatLng) => {
            itemRoute.routes.routeMap =
              itemRoute.routes.routeMap +
              Number(coordArea.lat()).toPrecision(8) +
              ',' +
              Number(coordArea.lng()).toPrecision(8) +
              ';';
          });

        if (itemRoute.markerMovida != undefined) {
          itemRoute.routes.movidaCoordIcon = '';
          itemRoute.markerMovida.forEach((markerAux: any) => {
            itemRoute.routes.movidaCoordIcon =
              itemRoute.routes.movidaCoordIcon +
              markerAux.name +
              ',' +
              markerAux.marker.position.lat() +
              ',' +
              markerAux.marker.position.lng() +
              ';';
          });
        }
        if (itemRoute.markerTerminals != undefined) {
          itemRoute.routes.terminalsCoordIcons = '';
          itemRoute.markerTerminals.forEach((markerAux: any) => {
            itemRoute.routes.terminalsCoordIcons =
              itemRoute.routes.terminalsCoordIcons +
              markerAux.name +
              ',' +
              markerAux.marker.position.lat() +
              ',' +
              markerAux.marker.position.lng() +
              ';';
          });
        }
        itemRoute.routes.email = this.user.email;
        this.vanTransferService.insertRoutes(itemRoute.routes).subscribe(
          (response: any) => {
            this.saveAreas(itemRoute, response);
            this.circularProgressiveWait = false;
            window.location.reload();
          },
          (error: HttpErrorResponse) => {
            this.toastService.show(
              'Erro ao cadastrar rota - ' + error.message,
              {
                classname: 'bg-danger text-center text-white',
                delay: 10000,
              }
            );
          }
        );
      } else if (itemRoute.routeWasEdit) {
        itemRoute.routes.routeMap = '';
        itemRoute.routes.email = this.user.email;
        itemRoute.routesPolyline
          .getPath()
          .getArray()
          .forEach((coordArea: google.maps.LatLng) => {
            itemRoute.routes.routeMap =
              itemRoute.routes.routeMap +
              Number(coordArea.lat()).toPrecision(8) +
              ',' +
              Number(coordArea.lng()).toPrecision(8) +
              ';';
          });
        this.circularProgressiveWait = true;
        if (itemRoute.markerMovida != undefined) {
          itemRoute.routes.movidaCoordIcon = '';
          itemRoute.markerMovida.forEach((markerAux: any) => {
            itemRoute.routes.movidaCoordIcon =
              itemRoute.routes.movidaCoordIcon +
              markerAux.name +
              ',' +
              markerAux.marker.position.lat() +
              ',' +
              markerAux.marker.position.lng() +
              ';';
          });
        } else {
          itemRoute.routes.movidaCoordIcon = '';
        }
        if (itemRoute.markerTerminals != undefined) {
          itemRoute.routes.terminalsCoordIcons = '';
          itemRoute.markerTerminals.forEach((markerAux: any) => {
            itemRoute.routes.terminalsCoordIcons =
              itemRoute.routes.terminalsCoordIcons +
              markerAux.name +
              ',' +
              markerAux.marker.position.lat() +
              ',' +
              markerAux.marker.position.lng() +
              ';';
          });
        } else {
          itemRoute.routes.terminalsCoordIcons = '';
        }
        this.vanTransferService.updateRoutes(itemRoute.routes).subscribe(
          (response: any) => {
            this.saveAreas(itemRoute, itemRoute.routes.id);
            this.circularProgressiveWait = false;
            window.location.reload();
          },
          (error: HttpErrorResponse) => {
            this.toastService.show('Erro ao editar rota - ' + error.message, {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            });
            this.circularProgressiveWait = false;
          }
        );
      } else {
        this.saveAreas(itemRoute, itemRoute.routes.id);
      }
    });
  }
  returnLocalCoordinates(id: any) {
    var index = this.vanTransferLocal.findIndex((item) => {
      return item.id == id;
    });
    return index < 0 ? '' : this.vanTransferLocal[index].coordinates;
  }
  returnLocal(id: any) {
    var index = this.vanTransferLocal.findIndex((item) => {
      return item.id == id;
    });
    return index < 0 ? '' : this.vanTransferLocal[index].name;
  }

  returnRoutesName(localId: number | null) {
    var names = '';
    this.routes.forEach((item: Routes) => {
      if (item.localId == localId) {
        names = names + ' | ' + item.name;
      }
    });

    return names;
  }

  changeEditableMarkerMovida(item: any, indexRoute: number) {
    item.forEach((markerAux: any) => {
      markerAux.marker.setDraggable(!markerAux.marker.editable);
    });
    this.localRoutesAreasEdit[indexRoute].routeWasEdit = true;
  }
  excludeMarkerMovida(item: any, indexRoute: number) {
    this.localRoutesAreasEdit[indexRoute].routeWasEdit = true;
    var indexMarker: number | undefined;
    indexMarker = this.localRoutesAreasEdit[indexRoute].markerMovida?.findIndex(
      (markerAux: any) => {
        return item[0].coordinates == markerAux.coordinates;
      }
    );
    if (indexMarker != undefined && indexMarker > -1) {
      this.localRoutesAreasEdit[indexRoute].markerMovida?.splice(
        indexMarker,
        1
      );
    }
  }

  changeEditableMarkerTerminal(item: any, indexRoute: number) {
    this.localRoutesAreasEdit[indexRoute].routeWasEdit = true;

    item.forEach((markerAux: any) => {
      markerAux.marker.setDraggable(!markerAux.marker.editable);
    });
    this.markerMovidaEdit.routeWasEdit = true;
  }
  excludeMarkerTerminal(item: any, indexRoute: number, indexMarker: number) {
    this.localRoutesAreasEdit[indexRoute].routeWasEdit = true;

    if (indexMarker != undefined && indexMarker > -1) {
      this.localRoutesAreasEdit[indexRoute].markerTerminals?.splice(
        indexMarker,
        1
      );
    }
  }

  addMarkerTerminals(item: any) {
    this.markerAddMovida = false;
    this.markerMovidaEdit = item;
    // this.routesAreasPolygonEdit.areas = [];
    this.drawingManager.drawingControl = true;
    this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.MARKER);

    this.drawingManager.drawingControlOptions.drawingModes = [
      google.maps.drawing.OverlayType.MARKER,
    ];
    this.drawingManager.setMap(this.drawingManager.map);
  }
  addMarkerMovida(item: any) {
    if (item.markerMovida == undefined) {
      this.markerAddMovida = true;
      this.markerMovidaEdit = item;
      // this.routesAreasPolygonEdit.areas = [];
      this.drawingManager.drawingControl = true;
      this.drawingManager.setDrawingMode(
        google.maps.drawing.OverlayType.MARKER
      );

      this.drawingManager.drawingControlOptions.drawingModes = [
        google.maps.drawing.OverlayType.MARKER,
      ];
      this.drawingManager.setMap(this.drawingManager.map);
    }
  }
  teste() {
    this.drawingManager.drawingControl = !this.drawingManager.drawingControl;
    this.drawingManager.drawingControlOptions.drawingMode =
      google.maps.drawing.OverlayType.POLYLINE;
    this.drawingManager.drawingControlOptions.drawingModes = [
      google.maps.drawing.OverlayType.POLYLINE,
    ];
    this.drawingManager.setMap(this.drawingManager.map);

    console.log(this.drawingManager.drawingControl);
  }

  async initDrawingManager() {
    // const drawingOptions = {
    //   //   drawingMode: google.maps.drawing.OverlayType.POLYGON,
    //   drawingControl: false,

    //   drawingControlOptions: {
    //     position: google.maps.ControlPosition.TOP_CENTER,
    //     drawingModes: [
    //       google.maps.drawing.OverlayType.POLYGON,
    //       google.maps.drawing.OverlayType.MARKER,
    //       google.maps.drawing.OverlayType.POLYLINE,
    //     ],
    //   },
    //   polygonOptions: {
    //     draggable: false,
    //     editable: false,
    //     strokeColor: '#000000',
    //   },
    //   polylineOptions: {
    //     draggable: false,
    //     editable: false,
    //     strokeColor: '#000db0',
    //   },
    //   markerOptions: {
    //     draggable: false,
    //   },
    // };
    // this.drawingManager.drawingControlOptions = drawingOptions;
    // this.drawingManager.drawingControlOptions.drawingControl = false;
    this.drawingManager.setMap(this.maps);

    google.maps.event.addListener(
      this.drawingManager,
      'overlaycomplete',
      (event: any) => {
        if (event.type === google.maps.drawing.OverlayType.POLYLINE) {
          var routesAux: LocalRoutesAreas = new LocalRoutesAreas();

          if (this.routeInitalBool) {
            this.localRoutesAreasEdit[0].routes.localId =
              this.localRoutesAreasEdit[0].localId;

            this.localRoutesAreasEdit[0].routesPolyline = this.prepareRoute(
              event.overlay.getPath().getArray()
            );
            this.routeInitalBool = false;
          } else if (this.routeAddButton) {
            this.localRoutesAreasEdit[0].routes.localId =
              this.localRoutesAreasEdit[0].localId;
            this.localRoutesAreasEdit[0].routesPolyline = this.prepareRoute(
              event.overlay.getPath().getArray()
            );
          }
          this.finishAddRoute();
          this.routeAddButton = false;
          event.overlay.setMap(null);
          this.drawingManager.setDrawingMode(null);
        } else if (event.type === google.maps.drawing.OverlayType.POLYGON) {
          var quantityAreas =
            this.routesAreasPolygonEdit.areas != undefined
              ? this.routesAreasPolygonEdit.areas.length
              : 0;
          if (
            this.routesAreasPolygonEdit.areas != undefined &&
            this.routesAreasPolygonEdit.areas.length > 0
          ) {
            quantityAreas = this.routesAreasPolygonEdit.areas.length;
            this.routesAreasPolygonEdit.areas.push({
              color: this.colorAreas[this.routesAreasPolygonEdit.areas.length],
              area: new Areas(),
              areaWasEdit: false,
              polygon: this.prepareAreas(
                event.overlay.getPath().getArray(),
                quantityAreas
              ),
            });
            this.routesAreasPolygonEdit.areas[quantityAreas].area.order =
              quantityAreas - 1;
          } else {
            this.routesAreasPolygonEdit.areas = [
              {
                color: this.colorAreas[0],
                area: new Areas(),
                areaWasEdit: false,
                polygon: this.prepareAreas(
                  event.overlay.getPath().getArray(),
                  quantityAreas
                ),
              },
            ];
            this.routesAreasPolygonEdit.areas[quantityAreas].area.order = 0;
          }

          event.overlay.setMap(null);
        } else if (event.type === google.maps.drawing.OverlayType.MARKER) {
          if (
            (this.markerAddMovida &&
              this.markerMovidaEdit.markerMovida == undefined) ||
            (this.markerAddMovida &&
              this.markerMovidaEdit.markerMovida != undefined &&
              this.markerMovidaEdit.markerMovida?.length < 1)
          ) {
            this.markerMovidaEdit.markerMovida = this.prepareMaker(
              event.overlay.position,
              true,
              '1'
            );
          } else {
            if (this.markerMovidaEdit.markerTerminals == undefined) {
              this.markerMovidaEdit.markerTerminals = this.prepareMaker(
                event.overlay.position,
                false,
                '1'
              );
            } else {
              this.markerMovidaEdit.markerTerminals.push(
                this.prepareMaker(
                  event.overlay.position,
                  false,
                  this.markerMovidaEdit.markerTerminals.length
                )[0]
              );
            }
          }
          this.clearDrawing();
          this.markerMovidaEdit.routeWasEdit = true;
          event.overlay.setMap(null);
        }
        event.overlay.setMap(null);
      }
    );
  }
  async openEdit(localId: number | null) {
    await this.initDrawingManager();
    if (!this.editOrAdd && localId != null) {
      this.editOrAdd = true;
      if (localId != null) {
        var routesAux: Routes[] = [];
        if (this.routes.length > 0) {
          this.routeInitalBool = false;
          routesAux = this.routes.filter((item) => {
            return item.localId == localId;
          });
          if (routesAux.length > 0) {
            routesAux.forEach((item: any) => {
              var routeAreasAux = this.routesAreas.filter((itemArea) => {
                return item.id == itemArea.routes_id;
              });
              var areasAux: Areas[] = this.areas.filter((itemArea) => {
                return (
                  routeAreasAux.findIndex((itemRouteArea) => {
                    return itemRouteArea.area_id == itemArea.id;
                  }) > -1
                );
              });
              var localRoutesAreasAux = new LocalRoutesAreas();
              localRoutesAreasAux.localId = item.localId
                ? item.localId
                : localId;
              localRoutesAreasAux.routeWasEdit = false;
              var areaPolygonAux: any = [];
              if (areasAux.length > 0) {
                areasAux = areasAux.sort((a: any, b: any) => {
                  if (Number(a.order) < Number(b.order)) return -1;
                  if (Number(a.order) > Number(b.order)) return 1;
                  return 0;
                });
              }
              var indexArea = 0;
              areasAux.forEach((areasItemAux: any) => {
                areaPolygonAux.push({
                  color: this.colorAreas[areasItemAux.order],
                  areaWasEdit: false,
                  area: {
                    id: areasItemAux.id,
                    message: areasItemAux.message,
                    estimatedTime: Number(areasItemAux.estimatedTime),
                    order: areasItemAux.order,
                  },
                  polygon: this.prepareAreas(
                    areasItemAux.coordinates,
                    areasItemAux.order
                  ),
                });
                indexArea = indexArea + 1;
                //  areasAux[indexArea].area.order = quantityAreas;
              });

              localRoutesAreasAux.areas = areaPolygonAux;
              localRoutesAreasAux.routesPolyline = this.prepareRoute(
                item.routeMap
              );
              if (item.movidaCoordIcon != '') {
                localRoutesAreasAux.markerMovida = this.prepareMaker(
                  item.movidaCoordIcon,
                  true,
                  ''
                );
              }
              if (item.terminalsCoordIcons != '') {
                localRoutesAreasAux.markerTerminals = this.prepareMaker(
                  item.terminalsCoordIcons,
                  false,
                  ''
                );
              }

              localRoutesAreasAux.routes = item;

              this.localRoutesAreasEdit.push(localRoutesAreasAux);

              this.maps.setZoom(15);
              this.maps.setCenter(
                localRoutesAreasAux.routesPolyline.getPath().getArray()[0]
              );
            });
          } else {
            var localRoutesAreasAux = new LocalRoutesAreas();
            localRoutesAreasAux.localId = localId ? localId : 0;
            localRoutesAreasAux.routeWasEdit = false;
            this.localRoutesAreasEdit.push(localRoutesAreasAux);
            var localCoordinates: any = this.returnLocalCoordinates(localId);
            this.routeInitalBool = true;
            if (localCoordinates != '') {
              this.drawingManager.map.setZoom(13);
              this.drawingManager.map.setCenter(
                this.prepareLatLng(localCoordinates)[0]
              );
            }
          }
        } else {
          var localRoutesAreasAux = new LocalRoutesAreas();
          localRoutesAreasAux.localId = localId ? localId : 0;
          localRoutesAreasAux.routeWasEdit = false;
          this.localRoutesAreasEdit.push(localRoutesAreasAux);
          var localCoordinates: any = this.returnLocalCoordinates(localId);
          this.routeInitalBool = true;
          if (localCoordinates != '') {
            this.drawingManager.map.setZoom(13);
            this.drawingManager.map.setCenter(
              this.prepareLatLng(localCoordinates)[0]
            );
          }
        }
      }
    } else {
      this.editOrAdd = false;
      this.localRoutesAreasEdit.forEach((item: LocalRoutesAreas) => {
        if (item.routesPolyline != undefined) {
          item.routesPolyline.setMap(null);
        }
        if (item.markerMovida != undefined) {
          item.markerMovida.forEach((itemMarker: any) => {
            itemMarker.marker.setMap(null);
          });
        }
        if (item.markerTerminals != undefined) {
          item.markerTerminals.forEach((itemMarkerTerminals: any) => {
            itemMarkerTerminals.marker.setMap(null);
          });
        }
        if (item.areas != undefined) {
          item.areas.forEach((itemArea: any) => {
            itemArea.polygon.setMap(null);
          });
        }
      });

      this.localRoutesAreasEdit = [];
    }
  }
}

export class LocalRoutesAreas {
  localId: number;
  routes: Routes;
  routeWasEdit: boolean;
  routesPolyline?: any;
  markerMovida?: [
    {
      marker: google.maps.Marker;
      name: string;
      coordinates: string;
    }
  ];
  markerTerminals?: [
    {
      marker: google.maps.Marker;
      name: string;
      coordinates: string;
    }
  ];
  areas?: [
    {
      color: string;
      area: Areas;
      areaWasEdit: boolean;
      polygon: any;
    }
  ];
  constructor() {
    this.localId = -1;
    this.routes = new Routes();
    this.routeWasEdit = false;
  }
}
